import { useDeviceType } from "./useDeviceType";
export default function DevicePage({ desktop, tablet, mobile }) {
  const device = useDeviceType();

  if (device === "mobile") return mobile;
  if (device === "tablet") return tablet;
  return desktop;
}
